function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import Box from './Box';
import Flex from './Flex';
import Heading from './Heading';
import XIcon from './icons/XIcon';
import UnstyledButton from './UnstyledButton';
export const DrawerHeader = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    text,
    onClose,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    ref: ref,
    __css: {
      py: 4,
      px: 4,
      bg: 'white',
      alignItems: 'center'
    }
  }, props), /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    fontSize: 2,
    flex: "1 1 0"
  }, text), onClose && /*#__PURE__*/React.createElement(Box, {
    sx: {
      color: 'gray.5',
      ':hover,:focus': {
        color: 'red'
      }
    }
  }, /*#__PURE__*/React.createElement(UnstyledButton, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(XIcon, {
    size: 14,
    display: "block"
  }))));
});
DrawerHeader.propTypes = {
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func
};
DrawerHeader.defaultProps = {};
DrawerHeader.displayName = 'DrawerHeader';
export default DrawerHeader;